import { z } from "zod";
import { chunkTypeEnum } from "./enums.js";

export const chunkSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  sourceVersionId: z.string().uuid(),
  sourcePageId: z.string().uuid().nullable(),
  content: z.string(),
  contextHeader: z.string(),
  contextText: z.string().nullable(),
  chunkIndex: z.number().int().nullable(),
  parentChunkId: z.string().uuid().nullable(),
  chunkType: chunkTypeEnum,
  sectionPath: z.array(z.string()),
  pageNumbers: z.array(z.number().int()),
  language: z.string().nullable(),
  contentHash: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).default({}),
  embeddingModel: z.string(),
  chunkingStrategy: z.string(),
  createdAt: z.date(),
});

export type Chunk = z.infer<typeof chunkSchema>;
